import React from 'react';
import AnalyticsDashboard from '../components/analytics/AnalyticsDashboard';

const AnalyticsPage = () => {
  return <AnalyticsDashboard />;
};

export default AnalyticsPage;
